import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Blotter from './pages/Blotter';
import ProtocolPage from './pages/ProtocolPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/protocol/:id" element={<ProtocolPage />} />
          <Route path="/" element={<Blotter />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;